import { useRef } from 'react';
import PropTypes from 'prop-types';
import RecommendationsItem from 'Components/profile/RecommendationsItem';
import RecommendationsItemSkeleton from 'Components/profile/RecommendationsItemSkeleton';

const RecommendationsList = ({
  interestsBased,
  isLoading,
  itemLimit,
  itemList,
  itemMap,
  isVideo,
  onFavoriteRecommendation,
  strings,
  totalCount,
}) => {
  const SKELETON_ITEMS = [...Array(itemLimit)];
  const listRef = useRef(null);
  const getItem = (id) => itemMap[id];

  const renderItem = (id) => {
    const item = getItem(id);
    if (!item) return null;
    return (
      <RecommendationsItem
        {...item}
        key={item.id}
        interestsBased={interestsBased}
        isVideo={isVideo}
        onFavorite={onFavoriteRecommendation}
        strings={strings}
      />
    );
  };

  const renderList = () => {
    if (isLoading) {
      listRef.current?.scrollTo(0, 0);
      return SKELETON_ITEMS.map((item, index) => (
        <RecommendationsItemSkeleton key={index} isVideo={isVideo} />
      ));
    }

    return itemList.map(renderItem);
  };

  return (
    <div
      className="recommendations-list"
      ref={listRef}
      style={{ overflowX: isLoading ? 'hidden' : 'auto' }}
    >
      <div className="recommendations-list__container">
        {renderList()}
        <div className="spacer"></div>
      </div>
    </div>
  );
};

RecommendationsList.propTypes = {
  interestsBased: PropTypes.bool,
  isLoading: PropTypes.bool.isRequired,
  itemLimit: PropTypes.number.isRequired,
  itemList: PropTypes.array.isRequired,
  itemMap: PropTypes.object.isRequired,
  isVideo: PropTypes.bool.isRequired,
  onFavoriteRecommendation: PropTypes.func.isRequired,
  strings: PropTypes.object.isRequired,
  totalCount: PropTypes.number.isRequired,
};

RecommendationsList.defaultProps = {
  interestsBased: false,
};

export default RecommendationsList;
